import { c as _c } from "react/compiler-runtime";
import { TooltipPropertiesType } from "@website/ui/tooltip/tooltip.types";
import pick from "lodash-es/pick";
import { useEffect, useRef } from "react";
export const useTooltip = properties => {
  const $ = _c(12);
  const {
    title
  } = properties;
  const contentReference = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = event => {
      if (event.key === "Escape" && contentReference.current) {
        contentReference.current.blur();
        event.stopPropagation();
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const escFunction = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      document.addEventListener("keydown", escFunction);
      return () => {
        document.removeEventListener("keydown", escFunction);
      };
    };
    t2 = [escFunction];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== title) {
    t3 = {
      ref: contentReference,
      "aria-label": title
    };
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== properties) {
    t4 = pick(properties, "id");
    $[5] = properties;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = {
      ...t4,
      role: "tooltip"
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = {
      tooltipProperties: t3,
      titleProperties: t5
    };
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};